<template>
  <b-form-group
    label="Şube Kodu"
    label-for="branch_code"
  >
    <validation-provider
      #default="{ errors }"
      name="Şube Kodu"
      rules="required"
    >
      <b-form-input
        id="branch_code"
        v-model="dataItem.branch_code"
        placeholder="Şube Kodu"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'BranchCode',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
